import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Card, { CardTypes } from "../Card";
import { AppDetails } from "../../configs";
import { Button } from "@mui/material";
import LazyImage from "../LazyImage";

function VillaOverview() {
  // Use the main property gallery instead of collecting from all room categories
  const allImages = AppDetails.gallery;

  return (
    <Card type={CardTypes.Secondary}>
      <div className="flex flex-col lg:flex-row gap-3">
        {/* Mixed Gallery */}
        <div className="flex lg:w-3/5 w-full justify-center bg-primary-main h-[250px] lg:h-[550px]">
          <Carousel dynamicHeight={true} infiniteLoop={true} showThumbs={false}>
            {allImages.map((image, index) => (
              <div key={index}>
                <LazyImage
                  src={image.original}
                  alt={`${AppDetails.app.name} ${index + 1}`}
                  className="h-[250px] lg:h-[550px] w-full object-contain"
                  containerClassName="h-[250px] lg:h-[550px] w-full"
                />
              </div>
            ))}
          </Carousel>
        </div>

        {/* Villa Info */}
        <div className="flex lg:w-2/5 flex-col">
          <div className="mb-3 lg:mx-3">
            <p className="text-xl font-bold text-secondary-main mb-2 text-center lg:text-left">
              {AppDetails.header.title}
            </p>

            <div className="hidden lg:block lg:py-2">
              <hr className="border-secondary-main" />
            </div>

            <p className="text-sm text-secondary-main mb-4 text-center lg:text-left">
              {AppDetails.header.description}
            </p>
            {/* CTA Button */}
            <div className="flex w-full justify-center">
              <div className="flex mb-3  w-1/2 ">
                <Button
                  className="!bg-primary-medium hover:!bg-secondary-main !text-primary-main hover:!text-secondary-light font-bold rounded w-full transition-all duration-500 ease-in-out hover:scale-105"
                  variant="contained"
                  href="/reserve"
                >
                  Book Now
                </Button>
              </div>
            </div>

            {/* Property Description */}

            <div className="bg-secondary-medium bg-opacity-80 rounded-lg p-3 border-l-4 border-primary-main max-w-3xl mx-auto my-3">
              <h3 className="text-lg font-semibold text-primary-main mb-2 text-center">
                About the Property
              </h3>
              <p className="text-xs text-primary-light leading-relaxed text-center">
                {AppDetails.propertyInfo.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default VillaOverview;
